<template>
  <div class="phoneInputWrapper">
    <input
        class="formInput"
        :class="{ 'formInput--error': error }"
        :value="displayValue"
        @input="handleInput"
        @keydown="handleKeydown"
        @focus="handleFocus"
        placeholder="+7(___) ___-__-__"
        type="tel"
        inputmode="numeric"
    />
    <div v-if="error" class="phoneInputWrapper__error">{{ error }}</div>
  </div>
</template>

<script>
import { computed } from 'vue';

export default {
  name: 'PhoneInput',
  props: ['modelValue', 'error'],
  emits: ['update:modelValue'],
  setup(props, { emit }) {

    function extractDigits(value) {
      const digits = (value || '').replace(/\D/g, '');
      let normalized = digits;
      if (normalized.startsWith('7') || normalized.startsWith('8')) {
        normalized = normalized.slice(1);
      }
      return normalized.slice(0, 10);
    }

    function formatPhone(digits) {
      let result = '+7(';
      if (digits.length > 0) result += digits.slice(0, 3);
      if (digits.length >= 3) result += ')';
      if (digits.length > 3) result += digits.slice(3, 6);
      if (digits.length >= 6) result += '-';
      if (digits.length > 6) result += digits.slice(6, 8);
      if (digits.length >= 8) result += '-';
      if (digits.length > 8) result += digits.slice(8, 10);
      return result;
    }

    const displayValue = computed(() => {
      const digits = extractDigits(props.modelValue);
      return digits.length > 0 ? formatPhone(digits) : '';
    });

    function handleInput(event) {
      const digits = extractDigits(event.target.value);
      const formatted = digits.length > 0 ? formatPhone(digits) : '';
      emit('update:modelValue', formatted);
      event.target.value = formatted;
    }

    function handleKeydown(event) {
      if (event.key === 'Backspace') {
        event.preventDefault();
        const digits = extractDigits(props.modelValue);
        if (digits.length > 0) {
          const newDigits = digits.slice(0, -1);
          const formatted = newDigits.length > 0 ? formatPhone(newDigits) : '';
          emit('update:modelValue', formatted);
        }
      }
    }

    function handleFocus(event) {
      if (!props.modelValue) {
        event.target.value = '+7(';
      }
    }

    return { displayValue, handleInput, handleKeydown, handleFocus };
  }
}
</script>

<style scoped lang="scss">
.phoneInputWrapper {
  width: 100%;

  &__error {
    color: var(--cd-danger);
    font-size: 12px;
    padding: 4px 20px 0;
  }
}

.formInput {
  width: calc(100% - 40px);
  display: inline-block;
  border-radius: 20px;
  padding: 5px 20px;
  background: var(--cd-field-bg);
  color: var(--cd-field-color);
  border: 1px solid var(--cd-field-border);
  height: 48px;

  &::placeholder {
    color: var(--cd-field-color-disabled);
    opacity: 1;
  }

  &:focus {
    outline: none;
    border-color: var(--cd-base-green);
    box-shadow: 0 0 5px rgba(98, 192, 100, 0.3);
  }

  &--error {
    border-color: var(--cd-danger) !important;
  }
}
</style>
